import {getSelectedDisplayValues} from '../../../product-pricing/priceUtils';
import {priceViewKey} from '../../../product-pricing/priceUtils';
import {storeDataInLocalStorage} from '../../../../_common/localStorage';
/**
 * find ancestor of an element that have a certain class cls
 * @param {*} el
 * @param {*} cls
 */
const _findAncestor = (el, cls) => {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
};



/**
 * event listener for dropdown toggle in product listing view menu
 * @param {*} e
 */
export function handleDesktopDropdown(e) {
  const self = e.currentTarget;
  const plpViewMenu = document.getElementById("plp-view-menu");
  const otherBtns = plpViewMenu.querySelectorAll(".view-menu-main__cta--desktop");

  otherBtns.forEach(otherBtn => {
    const otherBlock = otherBtn.parentElement.querySelector(".view-menu__descent-block");
    if (otherBlock !== undefined && otherBlock !== null && otherBlock !== self.nextElementSibling) {
      otherBlock.classList.remove("active");
    }
  });

  const showBlock = self.parentElement.querySelector(".view-menu__descent-block");
  if (showBlock !== undefined && showBlock !== null) {
    showBlock.classList.toggle("active");
  }
}


/**
 * handle option select from a dropdown menu in product listing view menu
 */
export  function handleOptSelect(e) {
  const self = e.currentTarget;
  const optsContainer = _findAncestor(self, "view-menu__root");
  const otherOpts = optsContainer.querySelectorAll(".view-menu__opt");
  const opt = self.querySelector(".view-menu__opt");
  const dropdown = _findAncestor(self, "view-menu__descent-block--desktop-dropdown");
  const cta = dropdown.previousElementSibling;
  const changeText = cta.querySelector(".view-menu-main__dropdown-selected");
  const bpMax01 = this;

  otherOpts.forEach(otherOpt => {
    otherOpt.classList.remove("selected");
  })

  opt.classList.add("selected");
  changeText.textContent = self.textContent.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

  if (!bpMax01.matches) {
    if (dropdown == null) return;
    dropdown.classList.remove("active");
  }
  const { showGstInclusive, displayPricesOption } = getSelectedDisplayValues(window);
  storeDataInLocalStorage(priceViewKey, JSON.stringify({ showGstInclusive, displayPricesOption }));
}
